/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
export const RESOURCE_KEY = 'recommendations-dismissed-jpd-resource-key';
export const ANALYTICS_ID = 'useResource.fetchRecommendationsDismissedJpd';
